import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1240. 受注案件削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
};
const destroySalesOrder = (props: Props) => {
  return axios.delete(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}`);
};

export const useDestroySalesOrder = () => {
  return useMutation({
    mutationFn: destroySalesOrder
  });
};